<template>
  <div class="product-add">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="基础设置" name="basic"></el-tab-pane>
      <el-tab-pane label="规格库存" name="spec"></el-tab-pane>
      <el-tab-pane label="商品详情" name="content"></el-tab-pane>
      <!-- <el-tab-pane label="租赁设置" name="fenqi"></el-tab-pane> -->
      <!-- <el-tab-pane label="高级设置" name="buyset"></el-tab-pane> -->
    </el-tabs>
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="180px">
      <!--基础信息-->
      <Basic v-show="activeName == 'basic'"></Basic>
      <!--规格设置-->
      <Spec v-show="activeName == 'spec'"></Spec>
      <!--商品详情-->
      <Content v-show="activeName == 'content'"></Content>
      <!-- 分期设置 -->
      <!-- <fenqi v-show="activeName == 'fenqi'"></fenqi> -->
      <!--高级设置-->
      <Buyset v-show="activeName == 'buyset'"></Buyset>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button
          size="small"
          type="primary"
          @click="onSubmit"
          :loading="formStatus.loading"
          >保存</el-button
        >
      </div>
    </el-form>
  </div>
</template>

<script>
import PorductApi from "@/api/product.js";
import Basic from "./part/Basic.vue";
import Spec from "./part/Spec.vue";
import Content from "./part/Content.vue";
import Buyset from "./part/Buyset.vue";
import fenqi from "./part/fenqi.vue";

export default {
  components: {
    /*基础信息*/
    Basic,
    /*规格信息*/
    Spec,
    /*商品详情*/
    Content,
    /*高级设置*/
    Buyset,
    /*分期信息*/
    fenqi
  },
  data() {
    return {
      formStatus: { loading: false },
      activeName: "basic",
      /*是否正在加载*/
      loading: false,
      /*form表单数据*/
      form: {
        model: {
          scene: "add",
          /*商品合同名称*/
          product_desc: "",
          /*商品名称*/
          product_name: "",
          /*商品编码*/
          product_no: "",
          /*商品分类*/
          category_id: null,
          /*商品图片*/
          image: [],
          // 热点商品
          spimage: [],
          // 商品标签
          shop_label: [],
          // 租赁说明
          // 租赁说明
          leaseImage: [],
          is_lease_description: 0,
          //常用说明
          commonImage: [],
          is_common_description: 0,
          //商品介绍
          is_picture: 0,
          contentImage: [],
          video_id: 0,
          poster_id: 0,
          /*商品卖点*/
          selling_point: "",
          /*规格类别,默认10单规格，20多规格*/
          spec_type: 20,
          /*库存计算方式,默认20付款减库存，10下单减库存*/
          deduct_stock_type: 20,
          sku: {},
          /*多规格类别*/
          spec_many: {
            /*多规格类别*/
            spec_attr: [],
            /*多规格表格数据*/
            spec_list: []
          },
          /*商品详情内容*/
          content: "",
          /*租赁详情内容*/
          lease_description: "",
          /*常用说明详情内容*/
          common_description: "",
          /*运费模板ID*/
          is_delivery_free: 0,
          delivery_id: "",
          /*商品状态*/
          product_status: 10,
          audit_status: 0,
          new_machine: 1,
          /*商品排序，默认100*/
          product_sort: 100,
          /*是否开启积分赠送,默认1为开启，0为关闭*/
          is_points_gift: 1,
          /*是否允许使用积分抵扣,默认1为允许，0为不允许*/
          is_points_discount: 1,
          /*最大积分抵扣数量*/
          max_points_discount: 0,
          /*平台分销是否开启*/
          is_agent: 0,
          /*是否开启单独分销,默认0为关闭，1为开启*/
          is_ind_agent: 0,
          /*分销佣金类型,默认10为百分比，20为固定金额*/
          agent_money_type: 10,
          /*一级佣金*/
          first_money: 0,
          /*二级佣金*/
          second_money: 0,
          /*三级佣金*/
          third_money: 0,
          /*是否虚拟商品*/
          is_virtual: 0,
          /*限购数量*/
          limit_num: 0,
          /*虚拟商品发货方式*/
          virtual_auto: 0,
          /*虚拟商品发货内容*/
          virtual_content: "",
          tableData: [
            {
              lease_time: "12",
              val: "100",
              value: "100"
            }
          ],
          // 是否有碎屏险
          broken_screen:0, //0表示没有，1表示有
          // 碎屏险金额
          broken_screen_price:0,
          // 展示方式
          display: []
        },
        /*商品分类*/
        category: [],
        /*运费模板*/
        delivery: [],
        /*会员等级*/
        gradeList: [],
        /*规格数据*/
        specData: null,
        /*是否锁住*/
        isSpecLocked: false,
        /*分销基础设置*/
        basicSetting: {},
        /*分销佣金设置*/
        agentSetting: {},
        audit_setting: {}
      }
    };
  },
  provide: function() {
    return {
      form: this.form,
      formStatus: this.formStatus
    };
  },
  created() {
    /*获取基础数据*/
    this.getBaseData();
  },
  methods: {
    /*获取基础数据*/
    getBaseData: function() {
      let self = this;
      PorductApi.getBaseData({}, true)
        .then(res => {
          self.formStatus.loading = false;
          Object.assign(self.form, res.data);
          self.form.category = res.data.category.filter(
            i => i.is_car_lease === 0
          );
        })
        .catch(error => {
          self.formStatus.loading = false;
        });
    },

    /*转JSON字符串*/
    convertJson(list) {
      let obj = {};
      list.forEach(item => {
        obj[item.grade_id] = item.product_equity;
      });
      return JSON.stringify(obj);
    },

    /*提交*/
    onSubmit: function() {
      let self = this;
      self.form.model.shop_label = self.form.model.shop_label.toString();
      let params = self.form.model;
      self.$refs.form.validate(valid => {
        if (valid) {
          if (params.is_delivery_free == 0) {
            params.delivery_id = 0;
          } else {
            if (params.delivery_id == "") {
              self.$message({
                message: "请选择运费模板",
                type: "error"
              });
              return;
            }
          }

          self.formStatus.loading = true;
          PorductApi.addProduct(
            {
              params: JSON.stringify(params)
            },
            true
          )
            .then(data => {
              self.formStatus.loading = false;
              self.$message({
                message: "添加成功",
                type: "success"
              });
              self.$router.push("/product/product/index");
            })
            .catch(error => {
              self.formStatus.loading = false;
            });
        } else {
          self.$message({
            message: "请检查必填项是否填写完整",
            type: "error"
          });
        }
      });
    },

    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
.basic-setting-content {
}

.product-add {
  padding-bottom: 100px;
}
</style>

<style lang="scss" scoped>
.basic-setting-content {
}

.product-add {
  padding-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/product/product1/add.vue